import { buildApiUrl, API_ENDPOINTS, setCsrfToken } from '../config/api.js'

let jwtToken = null

export const setJwtToken = (token) => {
  jwtToken = token
}

export const getJwtToken = () => {
  return jwtToken
}

export const sessionApi = {
  async login(email, password) {
    const url = buildApiUrl(API_ENDPOINTS.LOGIN)
    
          const response = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            credentials: 'include',
            mode: 'cors',
            cache: 'no-cache',
            body: JSON.stringify({ email, password })
          })
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}))
      throw new Error(errorData.error || `Request failed with status ${response.status}`)
    }
    
    const data = await response.json()
    
          if (data.message === 'Login successful') {
            setCsrfToken(data.csrf)
            setJwtToken(data.token)
            // Store token in localStorage for API requests
            localStorage.setItem('jwt_token', data.token)
          }
    
    return data
  },

  async logout() {
    const url = buildApiUrl(API_ENDPOINTS.LOGOUT)
    
    try {
      await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'include',
        mode: 'cors',
        cache: 'no-cache'
      })
    } catch (error) {
      console.warn('Logout request failed:', error)
    } finally {
      setCsrfToken(null)
      setJwtToken(null)
      // Clear token from localStorage
      localStorage.removeItem('jwt_token')
    }
    
    return Promise.resolve()
  }
}
